import React from 'react'
import img1 from '../Image/Rectangle 34625569.png'
import './Home.css'
import { Link } from 'react-router-dom'

function Home() {
    return (
        <div>
            <div className='container-fluid home-banner-div1'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-5'>
                            <div>
                                <img src={img1} className='img-fluid' alt="" />
                            </div>
                        </div>

                        <div className='col-lg-7 home-banner-col2-div1'>
                            <div className='home-banner-col2-text11'>
                                <h1>What is your current level?</h1>
                                <h4>Select one option</h4>

                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className='home-banner-btn1'>
                                            <Link to="/beg"><div className='btn1'>Beginner</div></Link>
                                        </div>
                                    </div>

                                    <div className='col-lg-6'>
                                        <div className='home-banner-btn1'>
                                            <Link to="/intermediate"><div className='btn1'>Intermediate</div></Link>
                                        </div>
                                    </div>

                                    <div className='col-lg-6'>
                                        <div className='home-banner-btn1'>
                                            <Link to="/advance"><div className='btn1'>Advance</div></Link>
                                        </div>
                                    </div>

                                    <div className='col-lg-6'>
                                        <div className='home-banner-btn1'>
                                            <Link to="/expert"><div className='btn1'>Expert</div></Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home
